import Vue from 'vue'
import store from './store';
import PanelFilterWidget from './components/PanelFilterWidget.vue';

Vue.config.productionTip = false;

let widgetEls = document.querySelectorAll('widget-panel-filter');

if (widgetEls.length) {
  widgetEls.forEach(el => {
    new Vue({
      el: el,
      store,
      render(h: any) {
        let codename = this.$el.attributes.getNamedItem('codename');
        let apibaseurl = this.$el.attributes.getNamedItem('apibaseurl');
        let language = this.$el.attributes.getNamedItem('language');

        return h(PanelFilterWidget, {
          props: {
              configRaw: {
                  codename: codename ? codename.value : null,
                  apibaseurl: apibaseurl ? apibaseurl.value : '',
                  language: language ? language.value : 'nl'
              }
          }
        });
      },
    });
  });
}
